import { useParams } from "react-router-dom";

import DigitalCampaignLearnMore from "../components/DigitalCampaignLearnMore";
import PostcardCampaignLearnMore from "../components/PostcardCampaignLearnMore";

const CampaignType = {
  "digital-campaign": <DigitalCampaignLearnMore />,
  "direct-mail-campaign": <PostcardCampaignLearnMore />,
};

const LearnMorePage = () => {
  const { campaignType } = useParams();

  return CampaignType[campaignType];
};

export default LearnMorePage;
